import React from 'react';
import autoBind from 'react-autobind';
import UserNotification from './Common/UserNotification.jsx';
import ContentService from '../services/ContentService';
import SlidingSessionNotificationStore from '../stores/SlidingSessionNotificationStore';
import ApplicationActions from '../actions/ApplicationActions';

function getState() {
    return {
        showExtendSessionNotification: SlidingSessionNotificationStore.getShowExtendSessionNotification()
    };
}

class SlidingSessionNotification extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getState();
        this.content = ContentService.getContent();
    }
    componentDidMount() {
        SlidingSessionNotificationStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        SlidingSessionNotificationStore.removeChangeListener(this._onChange);
    }

    _onChange() {
        this.setState(getState());
    }

    _onExtendSessionContinue() {
      ApplicationActions.onContinueSession();
    }

    render() {
        const ExtendSessionNotification = this.state.showExtendSessionNotification
        ? <UserNotification id="slidingSessionNotification"
            className={this.props.className}
            messageHeader={this.content.session.sessionHeader}
            message={this.content.session.sessionMessage}
            isHidden={!this.state.showExtendSessionNotification}
            isCountdown={true}
            showButton={true} buttonText="Continue" onClickButton={this._onExtendSessionContinue}/>
        : null;
        return (
            <div>{ExtendSessionNotification}</div>
        );
    }
}

export default SlidingSessionNotification


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/SlidingSessionNotification.jsx